import React, { useEffect, useReducer, useState } from "react";
import axios from 'axios';
import { clientImportExcel } from '../../../../../api/cp';
import local from "../../../../locale";
import {arrayChunk} from '../../../../utils';
import { ROLE_VIEWER } from '../../EventAccessPreModeration/constants'
import RegistrationFieldsTable from "./RegistrationFieldsTable";
import ImportedFileFieldsTable from "./ImportedFileFieldsTable";
import LoadingClients from "../LoadingClients";
import { Modal, Button, ProgressBar } from "react-bootstrap";
import { KONTUR_FOCUS_ORG_FIELD, TYPE_KONTUR_FOCUS } from '../constants';

const TableSheets = ({ event, roles, participationTypes, fields, sheets = [], onDone, onClose }) => {
    const CancelToken = axios.CancelToken;
    const [source, setSource] = useState(null);
    const [importData, setImportData] = useState(null);
    const [isListVisible, setListVisibility] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [progressState, updateProgressState] = useReducer(
        (prev, next) => {
            return { ...prev, ...next };
        },
        {
            importExcelUsersQueue: 0,
            totalQueue: 0,
            errorState: '',
        }
    );

    const [state, updateState] = useReducer(
        (prev, next) => {
            return { ...prev, ...next };
        },
        {
            sheet: [],
            sheetIndex: 0,
            selectedColumns: {},
            selectedRow: 0,
            columnCount: 0,
            role: ROLE_VIEWER,
            participationType: event.participationType === 'hybrid' ? null : event.participationType,
            sendMail: false,
            customValues: {},
        }
    );

    useEffect(() => {
        const source = CancelToken.source();
        setSource(source);
    }, []);

    function handleImportUsers(data = null) {
        setImportData(data);
        setListVisibility(!isListVisible);
    }

    async function handleApplyExcelList() {
        if (!importData) return;

        const hasKonturField = event.registrationFields.some(({field}) => field.type === TYPE_KONTUR_FOCUS);
        let {users, ...additionalData} = importData;

        if (hasKonturField) {
            users = users.map(({organizationName, organizationInn, organizationKpp, ...restFields}) => {
                return {
                    ...restFields,
                    [KONTUR_FOCUS_ORG_FIELD]: {
                        organizationName: organizationName || null, 
                        organizationInn: organizationInn || null, 
                        organizationKpp: organizationKpp || null, 
                    },
                };
            });
        }

        const usersQueue = arrayChunk(users, 100);
        const payload = {users: usersQueue, ...additionalData};

        updateProgressState({totalQueue: usersQueue.length});
        fetchImportedUsers(payload, progressState.importExcelUsersQueue, {cancelToken: source.token});
    }

    async function fetchImportedUsers(payload, progress = 0, params) {
        if (!isLoading) setIsLoading(true);
        
        const {users, ...additionalData} = payload;

        if (progress >= users.length || !source) {
            if (progressState.errorState?.length) {
                alert(progressState.errorState);
            }
            
            setTimeout(() => {
                setIsLoading(false);
                updateProgressState({importExcelUsersQueue: 0});
                onDone();
            }, 500);

            return 'done'
        };

        try {
            await clientImportExcel(event.eventKey, {users: users[progress], ...additionalData}, params);
        } catch (error) {
            console.error(error);
            if (error?.message) {
                updateProgressState(`${progressState.errorState} ${error?.message}`);
            }
        } finally {
            const newP = progress + 1;
            updateProgressState({importExcelUsersQueue: newP});
            fetchImportedUsers(payload, newP, params);
        }
    }

    function closeModal() {
        if (source) {
            source.cancel('Operation canceled by the user.');
            setSource(null);
        }
        onClose();
    }

    return (
        <>
            <Modal.Header>{local('importExcel.modal.title')}</Modal.Header>
            <Modal.Body>
                {
                    !isLoading
                        ? !isListVisible
                            ? <>
                                <p>{local('importExcel.modal.subtitle')}</p>
                                <RegistrationFieldsTable
                                    state={state}
                                    fields={fields}
                                    sheets={sheets}
                                    roles={roles}
                                    event={event}
                                    participationTypes={participationTypes}
                                    updateState={updateState}
                                >
                                    <ImportedFileFieldsTable onImport={handleImportUsers} /> 
                                </RegistrationFieldsTable>
                            </>
                            : <LoadingClients
                                fields={fields}
                                users={importData?.users ?? []}
                                onApply={handleApplyExcelList}
                                onClose={() => handleImportUsers()}
                            />
                        : <div>
                            <p>
                                Загрузка пользователей&nbsp;
                                {progressState.importExcelUsersQueue < progressState.totalQueue ? progressState.importExcelUsersQueue * 100 : importData?.users.length ?? 0} из {importData?.users.length ?? 0}
                                <br />
                                <span style={{fontSize: 12}}>Не закрывайте это окно до завершения импорта</span>
                            </p>
                            <ProgressBar
                                active
                                now={(progressState.importExcelUsersQueue / progressState.totalQueue) * 100}
                            />
                        </div>
                        
                }
            </Modal.Body>
            <Modal.Footer>
                {/* <Button onClick={onContinue} bsStyle="primary">Далее</Button> */}
                <Button onClick={closeModal}>Закрыть</Button>
            </Modal.Footer>
        </>
    );
};

export default TableSheets;
